import React from 'react';
import Header from './common/Header';
import Footer from './common/Footer';
import '../styles/Astrology.css';
import gamStar from '../assets/gam_star.png';

export default function Astrology({ onNavigateToSignIn }) {
  return (
    <div className="astrology-page">
      <Header activePage="courses" onNavigateToSignIn={onNavigateToSignIn} />

      {/* Gam Star positioned below header */}
      <div className="decorative-star right-star">
        <img src={gamStar} alt="Decorative Star" className="gam-star" />
      </div>

      <main className="astrology-main">
        <div className="astrology-container">
          <div className="astrology-hero">
            <h1 className="astrology-title">Astrology Courses</h1>
            <p className="astrology-subtitle">
              Learn the ancient art of astrology through our comprehensive courses designed for all skill levels
            </p>
          </div>

          <div className="astrology-content">
            <div className="astrology-section">
              <h2>Course Offerings</h2>
              <p>
                Our astrology courses are designed to take you from beginner to advanced practitioner,
                covering all aspects of traditional and modern astrological practice.
              </p>
            </div>

            <div className="astrology-section">
              <h2>What You'll Learn</h2>
              <ul className="astrology-list">
                <li>Fundamentals of astrological theory</li>
                <li>Birth chart interpretation techniques</li>
                <li>Planetary movements and aspects</li>
                <li>Houses and their meanings</li>
                <li>Predictive astrology methods</li>
                <li>Professional consultation skills</li>
              </ul>
            </div>

            <div className="astrology-section">
              <h2>Coming Soon</h2>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}